// src/helper/baseApi.js
import axios from "axios";
import { jwtDecode } from "jwt-decode";
import toast from "react-hot-toast";
import { getAppConfig } from "../config/appConfig";
import { globalEvent } from "./globalEvents";

const api = axios.create({
  headers: { Accept: "application/json" },
});

// --- JWT expiration check
const isTokenExpired = (token) => {
  try {
    const { exp } = jwtDecode(token);
    return Date.now() >= exp * 1000;
  } catch {
    return true;
  }
};

// --- Token refresh
let isRefreshing = false;
let refreshQueue = [];
let refreshAttempts = 0;

const fetchNewToken = async () => {
  try {
    globalEvent.emit("refresh:start");

    const refreshToken = localStorage.getItem("refreshToken");
    if (!refreshToken) throw new Error("No refresh token");

    const { accountMgtApiUrl } = await getAppConfig();
    const response = await axios.post(
      `${accountMgtApiUrl}/SourceUser/SourceUserToken`,
      {
        refresh_token: refreshToken,
        client_id: "poisum-mobile",
      }
    );

    const { access_token, refresh_token, user } = response?.data?.data || {};
    if (!user || !access_token) throw new Error("Invalid token response");

    localStorage.setItem("token", access_token);
    localStorage.setItem("refreshToken", refresh_token);
    localStorage.setItem("employeeId", user.linked_user_id);

    toast.success("Session refreshed, keeping you logged in...");

    refreshAttempts = 0;

    return access_token;
  } catch (err) {
    refreshAttempts += 1;
    console.error(`Token refresh failed (${refreshAttempts}/1):`, err);

    if (refreshAttempts >= 1) {
      setTimeout(() => {
      toast.error("Session expired, please log in again.");
      localStorage.clear();
      sessionStorage.clear();
      window.location.href = "/verifyEmail";
      return null;
    }, 1500);
    }
    toast.error("Session refresh failed. Retrying...");
    setTimeout(() => {
      window.location.reload();
    }, 1500);
    return null;
  } finally {
    globalEvent.emit("refresh:end");
  }
};

// --- Request interceptor
api.interceptors.request.use(
  async (config) => {
    let token = localStorage.getItem("token");

    if (token && isTokenExpired(token)) {
      if (!isRefreshing) {
        isRefreshing = true;
        token = await fetchNewToken();
        isRefreshing = false;

        refreshQueue.forEach((cb) => cb(token));
        refreshQueue = [];

        if (!token) return new Promise(() => {});
      } else {
        token = await new Promise((resolve) => refreshQueue.push(resolve));
      }
    }

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
  },
  (error) => Promise.reject(error)
);

export default api;


// // 🔧 Dynamic request function
// export const request = async ({ method, url, data, params, headers }) => {

//   console.log('method', method);
//   console.log('url', url);
//   console.log('data', data);
//   console.log('params', params);
//   console.log('headers', headers);
  
//   try {
//     const response = await api({
//       method,       // "get" | "post" | "put" | "delete" | etc.
//       url,          // endpoint path
//       data,         // request body (for POST/PUT/PATCH)
//       params,       // query string params (for GET)
//       headers,      // custom headers if needed
//     });
//     return response.data;
//   } catch (error) {
//     console.error("API Error:", error);
//     throw error;
//   }
// };